import { MessageCircle } from "lucide-react";
import { useSite } from "@/contexts/SiteContent";

export default function FloatingWhatsApp() {
  const { content } = useSite();
  const f = content?.floating_whatsapp;
  if (!f || f.enabled === false) return null;
  const num = (f.number || "").replace(/\D/g, "");
  if (!num) return null;
  const msg = encodeURIComponent(f.message || "Hi TARA Finserv, I'd like to talk.");
  const pos = f.position === "left" ? "left-5" : "right-5";
  return (
    <a
      href={`https://wa.me/${num}?text=${msg}`}
      target="_blank" rel="noreferrer"
      data-testid="floating-whatsapp"
      className={`fixed bottom-6 ${pos} z-50 h-14 w-14 rounded-full grid place-items-center text-white shadow-2xl transition-transform hover:scale-110`}
      style={{ background: "linear-gradient(135deg,#25D366,#128C7E)" }}
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="h-6 w-6"/>
      <span className="absolute inset-0 rounded-full animate-ping" style={{ background: "rgba(37,211,102,0.35)" }}/>
    </a>
  );
}
